import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { removePreset } from '@api/configurationComparison';

import { ESnackbarTypes } from '@enums/common';

import { DELETE_PRESET_TREE, PRESET_TREE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateRemovePreset = () => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: deleteTreePreset,
		isLoading: isLoadingDeleteTreePreset,
	} = useMutation<{ id: string }>({
		mutationKey: [DELETE_PRESET_TREE],
		mutationFn: removePreset,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.deleteTreePresetSuccess,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([PRESET_TREE])];
		},
	});

	return { deleteTreePreset, isLoadingDeleteTreePreset };
};
